import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-f8808144")
const _hoisted_1 = { id: "edit-image-component" }
const _hoisted_2 = { id: "image-size-wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Image Size", -1)
const _hoisted_4 = { id: "inputs-wrap" }
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "width-input" }, "Width", -1)
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("input", {
  class: "input-right",
  name: "right-input",
  placeholder: "in."
}, null, -1)
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "height-input" }, "Height", -1)
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("input", {
  class: "input-right",
  name: "right-input",
  placeholder: "in."
}, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { id: "border-wrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Image Border", -1)
const _hoisted_17 = { id: "border-controls" }
const _hoisted_18 = { id: "color-wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Color", -1)
const _hoisted_20 = { class: "range-wrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Border Width", -1)
const _hoisted_22 = { id: "styles-wrap" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Style", -1)
const _hoisted_24 = { id: "border-styles" }
const _hoisted_25 = { for: "solid" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Solid")
const _hoisted_27 = { for: "dotted" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Dotted")
const _hoisted_29 = { for: "dashed" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Dashed")
const _hoisted_31 = { id: "opacity-controls" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Transparency", -1)
const _hoisted_33 = { id: "slider-wrap" }
const _hoisted_34 = { id: "slider-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "width-input",
              class: "input-left",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageWidth = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWidth && _ctx.handleWidth(...args)))
            }, null, 544), [
              [_vModelText, _ctx.imageWidth]
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              id: "height-input",
              class: "input-left",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageHeight = $event)),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleHeight && _ctx.handleHeight(...args)))
            }, null, 544), [
              [_vModelText, _ctx.imageHeight]
            ]),
            _hoisted_12
          ])
        ])
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle({
          color: _ctx.resolutionWidth < 300 || _ctx.resolutionHeight < 300 ? '#ff0000' : '#fff',
        })
      }, [
        (_ctx.resolutionWidth === _ctx.resolutionHeight)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Resolution " + _toDisplayString(_ctx.resolution) + " DPI", 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, "Resolution " + _toDisplayString(_ctx.resolutionWidth) + " x " + _toDisplayString(_ctx.resolutionHeight) + " DPI", 1))
      ], 4),
      _createElementVNode("button", {
        "aria-label": "Reset image size",
        id: "reset-btn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetDPI && _ctx.resetDPI(...args)))
      }, " Reset Size ")
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", {
            id: "border-circle",
            ref: "borderElement",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args)))
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("input", {
            type: "range",
            min: "0",
            max: "100",
            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleBorderWidth && _ctx.handleBorderWidth(...args))),
            class: "slider",
            ref: "borderWidthRange"
          }, null, 544)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("label", _hoisted_25, [
            _createElementVNode("input", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setBorderStyle && _ctx.setBorderStyle(...args))),
              type: "radio",
              name: "border-style",
              id: "solid",
              value: "solid"
            }),
            _hoisted_26
          ]),
          _createElementVNode("label", _hoisted_27, [
            _createElementVNode("input", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setBorderStyle && _ctx.setBorderStyle(...args))),
              type: "radio",
              name: "border-style",
              id: "dotted",
              value: "dotted"
            }),
            _hoisted_28
          ]),
          _createElementVNode("label", _hoisted_29, [
            _createElementVNode("input", {
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.setBorderStyle && _ctx.setBorderStyle(...args))),
              type: "radio",
              name: "border-style",
              id: "dashed",
              value: "dashed"
            }),
            _hoisted_30
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("input", {
            type: "range",
            min: "0",
            max: "100",
            onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleOpacity && _ctx.handleOpacity(...args))),
            class: "slider",
            id: "opacity-slider",
            ref: "opacityRange"
          }, null, 544)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.opacitySlider) + "%", 1)
      ])
    ]),
    (_ctx.currentActiveObject.imageId)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          "aria-label": "Crop image",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('reCropImage')))
        }, " Crop Image "))
      : _createCommentVNode("", true)
  ]))
}